// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1___e23878d8b2a03619e00","cls2":"UserTaggingPingBodyStyles-cls2__f2854ca1ef59b9fcd3c1 UserTaggingPingBodyStyles-cls1___e23878d8b2a03619e00"};